import axios from 'axios';

const getUserToken = async () => {
    const token = await localStorage.getItem('token')
        ? localStorage.getItem('token') : '';
    return {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    }
};

export const getAxios = async (url, params) => {
    return await axios.get(url, { params, ...await getUserToken() });
};

export const postAxios = async (url, data) => {
    return await axios.post(url, data, await getUserToken());
};

export const patchAxios = async (url, data) => {
    return await axios.patch(url, data, await getUserToken());
};

export const putAxios = async (url, data) => {
    return await axios.put(url, data, await getUserToken());
};

export const deleteAxios = async (url) => {
    return await axios.delete(url, await getUserToken());
};